import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader'
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader.js';


const loadGLTF = async function(filePath){
  // Instantiate a loader
  const loader = new GLTFLoader();

  return new Promise((resolve, reject)=>{
    loader
      .load(filePath, // onScucess
        (gltf)=>{
          resolve(gltf);
        }, 
        null,         // onProgress
        (error)=>{    // onError
          console.trace(error)
          reject(error);
        });
  });
}

const loadRGBE = async function(dataType, filePath){
  return new Promise((resolve, reject)=>{
    new RGBELoader()
      .setDataType(dataType)
      .load(filePath, // onSuccess
        (texture)=>{
          resolve(texture);
        }, 
        null,         // onProgress
        (error)=>{    // onError
          reject(error);
        });
  });
}

const loadFBX = async function(filePath){
  return new Promise((resolve, reject)=>{
    new FBXLoader()
      .load(filePath, // onScucess
        (fbx)=>{
          resolve(fbx);
        }, 
        null,         // onProgress
        (error)=>{    // onError
          reject(error);
        });
  });
}

const loadTexture = async function(filePath){
  return new Promise((resolve, reject)=>{
    new THREE.TextureLoader().load(filePath, 
      (texture)=>{
        resolve(texture);
      },
      null,
      (error)=>{
        reject(error);
      });
  })
}

const replaceMaterial = function(mesh, to){
  let newMat = null;
  if(to == 'MeshPhongMaterial'){
    newMat = new THREE.MeshPhongMaterial;
  }else if(to == 'MeshLambertMaterial'){
    newMat = new THREE.MeshLambertMaterial;
  }else if(to == 'MeshBasicMaterial'){
    newMat = new THREE.MeshBasicMaterial;
  }

  // convert
  if(newMat !== null){
    const oldMat = mesh.material;
    if(newMat.type == "MeshLambertMaterial" ||
             newMat.type == "MeshBasicMaterial"){
      newMat.map = oldMat.map
      newMat.color = oldMat.color;
      newMat.opacity = oldMat.opacity;
      newMat.transparent = oldMat.transparent;
      newMat.envMap = oldMat.envMap;
    }else if(newMat.type == "MeshPhongMaterial"){
      newMat.map = oldMat.map
      newMat.color = oldMat.color;
      newMat.opacity = oldMat.opacity;
      newMat.transparent = oldMat.transparent;
      newMat.envMap = oldMat.envMap;
      newMat.normalMap = oldMat.normalMap;
      newMat.normalMapType = oldMat.normalMapType;
      if(newMat.normalMap != null)
        newMat.name = "normalmap"
      newMat.specular = new THREE.Color( 0x000000 );
      newMat.shininess = 0;
      newMat.emissiveIntensity = 0; 
      
      // console.log(newMat.specular, newMat.emissive, newMat)
    }else{
      console.error("no implementation")
    }
    
    mesh.material.dispose();

    mesh.material = newMat;
  }else{
    console.error("no implementation")
  }

}

const loadCubeMap = async function(filePath, format){
  const urls = [
    filePath + 'posx' + format, filePath + 'negx' + format,
    filePath + 'posy' + format, filePath + 'negy' + format,
    filePath + 'posz' + format, filePath + 'negz' + format
  ];
  return new Promise((resolve, reject)=>{
    new THREE.CubeTextureLoader().load(urls, 
        (texture)=>{
          resolve(texture);
        }, 
        null,         // onProgress
        (error)=>{    // onError
          reject(error);
        });
    });
}

export {loadGLTF, loadRGBE, loadFBX, replaceMaterial, loadCubeMap, loadTexture};
